import { t } from '@lingui/macro';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeRidingZonesCompetitorsOperatorsFilter } from '../../../ac/onChangeMapFilters';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';


const RidingZonesCompetitorsComponent = ({
    mapFilters,
    onChangeRidingZonesCompetitorsOperatorsFilter,
}) => (
    <div>
        {/* Динамический фильтр операторов */}
        <DynamicAttributeFilter
            title={t`Операторы (зоны катания)`}
            attributeTypes={functionalAreasYandexUrentTypes}
            availableValues={mapFilters.ridingZonesCompetitorsAvailableOperators}
            disabledValues={mapFilters.ridingZonesCompetitorsOperatorsDisabled}
            onToggle={onChangeRidingZonesCompetitorsOperatorsFilter}
            inputNamePrefix="riding-zones-operator"
        />
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    { onChangeRidingZonesCompetitorsOperatorsFilter }
)(RidingZonesCompetitorsComponent);

export const RidingZonesCompetitorsFilter = withDisplayedLayersCheck(ConnectedComponent, 'Зоны катания (конкуренты)');
